/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SentimentNegativeIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Sentiment Negative',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm5.473 6.432c1.657 0 3 1.679 3 3.75s-1.343 3.75-3 3.75-3-1.679-3-3.75 1.343-3.75 3-3.75Zm-11.108.1c1.656 0 3 1.679 3 3.75s-1.344 3.75-3 3.75-3-1.679-3-3.75 1.343-3.748 3-3.748Zm14.512 16.11-.942.476a1 1 0 0 1-1.124-.152c-.333-.3-.727-.659-.829-.73a10.487 10.487 0 0 0-5.941-1.736 10.474 10.474 0 0 0-6 1.771c-.124.088-.489.424-.8.717a1 1 0 0 1-1.134.161l-.928-.47a1 1 0 0 1-.29-1.564c.232-.257.442-.483.526-.558a13.008 13.008 0 0 1 8.626-3.057 12.969 12.969 0 0 1 8.729 3.15c.047.043.208.219.4.432a1 1 0 0 1-.293 1.56Z"
    />
  </svg>`;
};
